/**
 * Collection Filter Grid - View Toggle (Grid/List)
 * Handles Grid/List view switching with localStorage persistence
 * and MutationObserver to restore view after AJAX filter updates
 */
(function () {
  const STORAGE_KEY = 'collection-view-preference';
  // List view is desktop-only: its card layout (fixed 260px image column +
  // non-shrinkable action column, ~536px min-content) plus the vertical facets
  // sidebar does not fit below Dawn's 990px desktop breakpoint.
  const DESKTOP_BREAKPOINT = 990;

  function getPreferredView() {
    try {
      // Whitelist the stored value: anything else (corrupted storage, renamed
      // view values from an older/newer version) must not reach data-view —
      // an unknown value matches neither view's CSS and breaks the layout.
      var stored = localStorage.getItem(STORAGE_KEY);
      return stored === 'grid' || stored === 'list' ? stored : 'list';
    } catch (e) {
      return 'grid';
    }
  }

  function savePreferredView(view) {
    try {
      localStorage.setItem(STORAGE_KEY, view);
    } catch (e) {
      // localStorage unavailable
    }
  }

  function isBelowDesktop() {
    return window.innerWidth < DESKTOP_BREAKPOINT;
  }

  function applyView(view) {
    const grid = document.getElementById('product-grid');
    if (!grid) return;

    // Force grid below the desktop breakpoint
    const effectiveView = isBelowDesktop() ? 'grid' : view;
    grid.setAttribute('data-view', effectiveView);

    // Update card-specs layout attribute
    grid.querySelectorAll('.card-specs').forEach(function (el) {
      el.setAttribute('data-layout', effectiveView);
    });

    // Update toggle button active state
    document.querySelectorAll('[data-view-toggle]').forEach(function (toggle) {
      toggle.querySelectorAll('.collection-view-toggle__btn').forEach(function (btn) {
        var btnView = btn.getAttribute('data-view');
        btn.classList.toggle('collection-view-toggle__btn--active', btnView === effectiveView);
      });
    });
  }

  function initToggle() {
    document.querySelectorAll('[data-view-toggle]').forEach(function (toggle) {
      toggle.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-view]');
        if (!btn || isBelowDesktop()) return;

        var view = btn.getAttribute('data-view');
        savePreferredView(view);
        applyView(view);
      });
    });
  }

  function observeGridChanges() {
    var container = document.getElementById('ProductGridContainer');
    if (!container) return;

    var observer = new MutationObserver(function () {
      // After AJAX filter update, restore the view preference
      var preferredView = getPreferredView();
      applyView(preferredView);
    });

    observer.observe(container, {
      childList: true,
      subtree: true
    });
  }

  function handleResize() {
    var view = getPreferredView();
    applyView(view);
  }

  /* ========================================
     AJAX Add to Cart
     ======================================== */

  function initAjaxCart() {
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('.card-atc-form');
      if (!form) return;

      e.preventDefault();
      var btn = form.querySelector('.card-atc-btn');
      if (!btn || btn.classList.contains('card-atc-btn--loading')) return;

      var originalText = btn.querySelector('.card-atc-btn__text');
      var savedText = originalText ? originalText.textContent : '';
      btn.classList.add('card-atc-btn--loading');
      if (originalText) originalText.textContent = '...';

      var formData = new FormData(form);
      var body = JSON.stringify({
        items: [{
          id: Number(formData.get('id')),
          quantity: Number(formData.get('quantity')) || 1
        }],
        sections: 'cart-icon-bubble'
      });

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: body
      })
        .then(function (res) {
          if (!res.ok) throw new Error(res.statusText);
          return res.json();
        })
        .then(function (data) {
          if (originalText) originalText.textContent = 'Hinzugefügt ✓';
          btn.classList.remove('card-atc-btn--loading');
          btn.classList.add('card-atc-btn--success');
          // Replace the whole header icon with the server-rendered section:
          // with an empty cart the theme renders no .cart-count-bubble element
          // (and shows the empty-cart icon), so patching the badge text alone
          // does nothing on the first add
          var icon = document.getElementById('cart-icon-bubble');
          var sectionHtml = data.sections && data.sections['cart-icon-bubble'];
          if (icon && sectionHtml) {
            // The add already succeeded — a failed icon update must never
            // fall through to the .catch below (it would re-submit the form
            // and add the item a second time), so guard instead of throwing
            var section = new DOMParser()
              .parseFromString(sectionHtml, 'text/html')
              .querySelector('.shopify-section');
            if (section) icon.innerHTML = section.innerHTML;
          }
          setTimeout(function () {
            if (originalText) originalText.textContent = savedText;
            btn.classList.remove('card-atc-btn--success');
          }, 1500);
        })
        .catch(function () {
          // Fallback: submit the form normally (reset the button first in
          // case navigation is blocked and the page lives on)
          btn.classList.remove('card-atc-btn--loading');
          if (originalText) originalText.textContent = savedText;
          form.submit();
        });
    });
  }

  // Initialize
  function init() {
    var preferredView = getPreferredView();
    applyView(preferredView);
    initToggle();
    observeGridChanges();
    initAjaxCart();

    // Hide toggle on mobile, show on desktop
    window.addEventListener('resize', handleResize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
